import * as React from 'react'
export const SvgAccountSelected = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" {...props}>
    <path d="M11.5 12.24a9.52 9.52 0 019.5 9.19.62.62 0 01-.62.62H2.62a.62.62 0 01-.62-.62 9.52 9.52 0 019.5-9.19zM11.5 2.05a4.69 4.69 0 11-4.69 4.69 4.69 4.69 0 014.69-4.69z" />
  </svg>
)
export default SvgAccountSelected
